import PaymentScheduleListGroup from '@/pages/payment-schedules/PaymentScheduleListGroup.vue'
import PaymentScheduleDetailsUnit from '@/pages/payment-schedules/PaymentScheduleDetailsUnit.vue'
import PaymentScheduleDaySelection from '@/pages/payment-schedules/PaymentScheduleDaySelection.vue'
import FormPageScheduleUnit from '@/pages/payment-schedules/forms/FormPageScheduleUnit.vue'
import FormPageScheduleBulk from '@/pages/payment-schedules/forms/FormPageScheduleBulk.vue'
import FormPageScheduleGroup from '@/pages/payment-schedules/forms/FormPageScheduleGroup.vue'
import PaymentScheduleDetailsBulk from '@/pages/payment-schedules/PaymentScheduleDetailsBulk.vue'

export default [
  {
    path: '/payment-schedules/:type',
    component: PaymentScheduleListGroup,
    props: true
  },
  {
    path: '/payment-schedules/unit/details/:id',
    component: PaymentScheduleDetailsUnit,
    props: true
  },
  {
    path: '/payment-schedules/bulk/details/:id',
    component: PaymentScheduleDetailsBulk,
    props: true
  },
  {
    path: '/payment-schedules/day/:date/',
    component: PaymentScheduleDaySelection,
    props: true
  },
  {
    path: '/payment-schedules/new/unit/',
    component: FormPageScheduleUnit,
    props: true
  },
  {
    path: '/payment-schedules/new/bulk/',
    component: FormPageScheduleBulk,
    props: true
  }
  // {
  //   path: '/payment-schedules/new/group/',
  //   component: FormPageScheduleGroup,
  //   props: true
  // }
]
